import { Component, OnDestroy, AfterViewInit, ViewChild, Output, EventEmitter } from '@angular/core'
import { Router } from '@angular/router'
import { GridsterConfig, GridsterItem } from 'angular-gridster2';

import { appStateProvider } from '../../../insa-providers'
import { InsaService } from '../../../insa-services'
import { MainEntryDataModel } from '../../../insa-models';
//import { GridsterItemComponent } from 'angular-gridster2/dist/gridsterItem.component';
//import { MenuEntry } from '../insa-main-widgets/menuEntry.component';

@Component({
  selector: 'insaweb-insa-main-window',
  templateUrl: 'insa-main-window.component.html'
})

export class InsaMainWindowComponent implements OnDestroy, AfterViewInit {
  @Output() chartResizingEvent: EventEmitter<any> = new EventEmitter();

  private cellSize = 100;
  private mainEntry: MainEntryDataModel[];
  private spaceWidth: number;
  private spaceHeight: number;
  private gridsterColumnNumber: number;
  private gridsterRowNumber: number;
  private containermargin = {
    top,
  }

  private gridsterBasicParams = {
    margin: 5,
    cellWidth: this.cellSize,
    cellHeight: this.cellSize,
  }

  private addEvent = function (object, type, callback) {
    if (object == null || typeof (object) == 'undefined') return;
    if (object.addEventListener) {
      object.addEventListener(type, callback, false);
    }
    else if (object.attachEvent) {
      object.attachEvent("on" + type, callback);
    }
    else {
      object["on" + type] = callback;
    }
  };

  @ViewChild('gridster') gridster;
  private gridsterOptions: GridsterConfig = {
    gridType: 'fit',
    compactType: 'compactUp&Left',
    destroyCallback: undefined,
    itemChangeCallback: this.saveMainWindowLayout.bind(this),
    itemResizeCallback: undefined,
    itemInitCallback: this.setChartWidgetSize,
    itemRemovedCallback: undefined,
    margin: this.gridsterBasicParams.margin,
    outerMargin: true,
    mobileBreakpoint: 640,
    minCols: 1,
    maxCols: 20,
    minRows: 1,
    maxRows: 20,
    maxItemCols: 10,
    minItemCols: 1,
    maxItemRows: 10,
    minItemRows: 1,
    maxItemArea: 200,
    minItemArea: 1,
    defaultItemCols: 1,
    defaultItemRows: 1,
    fixedColWidth: this.gridsterBasicParams.cellWidth,
    fixedRowHeight: this.gridsterBasicParams.cellHeight,
    keepFixedHeightInMobile: false,
    keepFixedWidthInMobile: false,
    scrollSensitivity: 10,
    scrollSpeed: 20,
    enableEmptyCellClick: false,
    enableEmptyCellContextMenu: false,
    enableEmptyCellDrop: false,
    enableEmptyCellDrag: false,
    emptyCellClickCallback: undefined,
    emptyCellContextMenuCallback: undefined,
    emptyCellDropCallback: undefined,
    emptyCellDragCallback: undefined,
    emptyCellDragMaxCols: 50,
    emptyCellDragMaxRows: 50,
    draggable: {
      delayStart: 0,
      enabled: true,
      ignoreContentClass: 'gridster-item-content',
      ignoreContent: true,
      dragHandleClass: 'cardup',
      stop: undefined
    },
    resizable: {
      delayStart: 0,
      enabled: true,
      stop: this.setChartWidgetSize,
      handles: {
        s: true,
        e: true,
        n: true,
        w: true,
        se: true,
        ne: true,
        sw: true,
        nw: true
      }
    },
    swap: false,
    pushItems: true,
    disablePushOnDrag: false,
    disablePushOnResize: false,
    pushDirections: { north: true, east: true, south: true, west: true },
    pushResizeItems: true,
    displayGrid: 'onDrag&Resize',
    disableWindowResize: false,
    disableWarnings: false,
    scrollToNewItems: false,
    disableAutoPositionOnConflict: false
  }
  //private gridsterFavoritesItem :GridsterItem = {cols: 6, rows: 6, y: 18, x: 0}
  private gridsterFavoritesItem: GridsterItem = { cols: 2, rows: 1, y: 0, x: 0 }
  private gridsterLastUsedItem: GridsterItem = { cols: 2, rows: 1, y: 2, x: 0 }
  private gridsterWelcomeItem: GridsterItem = { cols: 1, rows: 1, y: 4, x: 0 }

  private gridsterDonutChartItem: GridsterItem = { cols: 3, rows: 2, y: 1, x: 4 }
  private gridsterBarChartItem: GridsterItem = { cols: 1, rows: 1, y: 4, x: 5 }
  private gridsterSettingsItem: GridsterItem = { cols: 2, rows: 1, y: 2, x: 1 }
  
  // private gridsterSearchItem: GridsterItem = { cols: 2, rows: 1, y: 2, x: 12 }
  private gridsterTaskListItem: GridsterItem = { cols: 2, rows: 2, y: 5, x: 5 }

  // this is default layout loaded if there is nothing in localStorage
  private defaultGridsterLayout = [
    { "name": "Favorites", "visible": true, "gridsterItem": { "cols": 2, "rows": 1, "y": 0, "x": 0 }, "cannotHide": false },
    { "name": "Last Used", "visible": true, "gridsterItem": { "cols": 2, "rows": 2, "y": 0, "x": 2 }, "cannotHide": false },
    { "name": "Welcome", "visible": true, "gridsterItem": { "cols": 1, "rows": 1, "y": 0, "x": 4 }, "cannotHide": true },

    { "name": "Donut Chart", "visible": true, "gridsterItem": { "cols": 3, "rows": 2, "y": 1, "x": 4 }, "cannotHide": false },
    { "name": "Bar Chart", "visible": true, "gridsterItem": { "cols": 1, "rows": 1, "y": 4, "x": 5 }, "cannotHide": false },
    { "name": "Settings", "visible": true, "gridsterItem": { "cols": 1, "rows": 1, "y": 2, "x": 1 }, "cannotHide": true },
  
    // { "name": "Search", "visible": true, "gridsterItem": { "cols": 2, "rows": 1, "y": 4, "x": 6 }, "cannotHide": true },
    { "name": "Tasks", "visible": true, "gridsterItem": { "cols": 2, "rows": 2, "y": 5, "x": 5 }, "cannotHide": false },
  ]

  // below collection is used to save/restore layout easier
  // add new widgets also to the list it!
  private widgetList = [
    {
      name: 'Favorites',
      visible: true,
      gridsterItem: this.gridsterFavoritesItem,
      cannotHide: false
    },
    {
      name: 'Last Used',
      visible: true,
      gridsterItem: this.gridsterLastUsedItem,
      cannotHide: false
    },
    {
      name: 'Donut Chart',
      visible: true,
      gridsterItem: this.gridsterDonutChartItem,
      cannotHide: false
    },
    {
      name: 'Bar Chart',
      visible: true,
      gridsterItem: this.gridsterBarChartItem,
      cannotHide: false
    },
    {
      name: 'Settings',
      visible: true,
      gridsterItem: this.gridsterSettingsItem,
      cannotHide: true
    },
    {
      name: 'Welcome',
      visible: true,
      gridsterItem: this.gridsterWelcomeItem,
      cannotHide: true
    },
    // {
    //   name: 'Search',
    //   visible: true,
    //   gridsterItem: this.gridsterSearchItem,
    //   cannotHide: true
    // },
    {
      name: 'Tasks',
      visible: true,
      gridsterItem: this.gridsterTaskListItem,
      cannotHide: false
    }
  ]

  saveMainWindowLayout(gridsterItem, gridsterItemComponent) {
    localStorage['mainWindowLayout'] = JSON.stringify(this.widgetList);
    return true;
  }

  loadMainWindowLayout() {
    let layouts
    let retValue = false
    if (localStorage['mainWindowLayout']) {
      retValue = true
      layouts = JSON.parse(localStorage['mainWindowLayout']);
    }
    else {
      // return false here if you want to use layout function setGridsterandItemsSize()
      retValue = true
      layouts = this.defaultGridsterLayout;
      // TODO: adjust width based on window size?
    }
    this.widgetList.forEach((g, i) => {
      g.visible = layouts[i].visible;
      g.name = layouts[i].name;
      g.cannotHide = layouts[i].cannotHide;
      Object.assign(g.gridsterItem, layouts[i].gridsterItem);
    })
    this.gridster.optionsChanged();
    return retValue;
  }

  isVisible(griddy) {
    return (this.widgetList.find(w => w.gridsterItem === griddy)).visible
  }

  setGridsterandItemsSize() {
    // prevent console error:
    // ERROR TypeError: Cannot read property 'updateOptions' of undefined
    if (this.gridster) {
      this.spaceWidth = $('gridster').width();
      this.spaceHeight = $('gridster').height();
      this.gridsterColumnNumber = Math.floor((this.spaceWidth - this.gridsterBasicParams.margin) / (this.cellSize + this.gridsterBasicParams.margin));
      this.gridsterRowNumber = Math.floor((this.spaceWidth - this.gridsterBasicParams.margin) / (this.cellSize + this.gridsterBasicParams.margin));
      this.gridsterOptions.maxCols = this.gridsterColumnNumber;
      this.gridsterOptions.maxRows = this.gridsterRowNumber;
      this.gridsterFavoritesItem.cols = this.gridsterColumnNumber;
      this.gridsterLastUsedItem.cols = this.gridsterColumnNumber;
      this.gridster.optionsChanged();
    }
  }

  // calculateSizeForGridster(){
  //   var container = document.getElementsByClassName("canvas")[0];
  //   var style = window.getComputedStyle(container);

  //   console.log("COntainer margin:");
  //   console.log(style.marginTop);
  // }

  setChartWidgetSize(gridsterItem, gridsterItemComponent) {
  }

  changeLanguage() {
    // this is for changing INSA language
    // TODO: call API with this.selectedLanguage as parameter
  }

  constructor(private _insaService: InsaService, private _appStateProvider: appStateProvider, private _router: Router) {
    this.addEvent(window, "resize", () => {
      this.setGridsterandItemsSize();
    })
  }

  ngAfterViewInit() {
    // if no customizations were made do the initial setting of gridster
    if (!this.loadMainWindowLayout()) {
      this.setGridsterandItemsSize();
    }
  }
  ngOnDestroy() {
  }
}


// WEBPACK FOOTER //
// ./app/insa-components/insa-main/insa-main-window/insa-main-window.component.ts